import { WikiLayout } from "@/components/WikiLayout";
import { WikiPage } from "@/components/WikiPage";

const Training = () => {
  return (
    <WikiLayout>
      <WikiPage 
        title="Training Overview" 
        description="Your path to becoming a certified BlueLux technician"
      >
        <section className="space-y-6">
          <p>
            BlueLux's training program is designed to get you servicing pools independently 
            within 2-3 weeks while building the skills for long-term success as an independent contractor.
          </p>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Phase 1: Foundation (Days 1-5)</h2>
          <div className="space-y-3">
            <p className="text-muted-foreground">
              Learn the fundamentals of pool chemistry, equipment, and BlueLux service standards.
            </p>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li><strong>Water Chemistry Basics:</strong> pH, chlorine, alkalinity, calcium hardness, cyanuric acid</li>
              <li><strong>Testing Procedures:</strong> Proper testing techniques and equipment calibration</li>
              <li><strong>Common Pool Equipment:</strong> Pumps, filters, chlorinators, timers, valves</li>
              <li><strong>Chemical Handling:</strong> Safe storage, handling, and application procedures</li>
              <li><strong>Safety Protocols:</strong> PPE requirements, emergency response, heat safety</li>
              <li><strong>Service Documentation:</strong> Digital reporting system and customer communication</li>
              <li><strong>BlueLux Quality Standards:</strong> Service checklist and quality expectations</li>
            </ul>
          </div>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Phase 2: Hands-On Training (Days 6-15)</h2>
          <div className="space-y-3">
            <p className="text-muted-foreground">
              Apply your knowledge under supervision, building confidence and efficient techniques.
            </p>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li><strong>Route Shadowing:</strong> Follow experienced technician through complete service routes</li>
              <li><strong>Water Chemistry Practice:</strong> Test, diagnose, and balance pools under supervision</li>
              <li><strong>Cleaning Techniques:</strong> Master skimming, brushing, vacuuming, and tile cleaning</li>
              <li><strong>Equipment Inspection:</strong> Check pumps, filters, chlorinators, identify problems</li>
              <li><strong>Customer Interaction:</strong> Professional communication and service explanations</li>
              <li><strong>Time Management:</strong> Efficient service completion and route optimization</li>
              <li><strong>Problem Solving:</strong> Troubleshoot common issues (cloudy water, algae, equipment failures)</li>
            </ul>
          </div>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Phase 3: Independent Servicing (Weeks 3+)</h2>
          <div className="space-y-3">
            <p className="text-muted-foreground">
              Begin servicing your own route independently with ongoing support and quality verification.
            </p>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li><strong>Independent Route Service:</strong> Complete your assigned route (15-25 pools) each week</li>
              <li><strong>Quality Audits:</strong> Regular check-ins and pool inspections to ensure standards</li>
              <li><strong>Performance Feedback:</strong> Weekly reviews on efficiency, quality, and customer satisfaction</li>
              <li><strong>Advanced Troubleshooting:</strong> Handle complex chemistry and equipment problems</li>
              <li><strong>Customer Relationships:</strong> Build trust and loyalty with your clients</li>
              <li><strong>Service Expansion:</strong> Learn to identify and quote additional services (repairs, upgrades)</li>
            </ul>
          </div>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Ongoing Development</h2>
          <p className="text-muted-foreground">
            Training doesn't stop after your first month. BlueLux provides continuous learning 
            opportunities to help you maximize quality, efficiency, and earnings:
          </p>
          <ul className="list-disc list-inside space-y-2 text-muted-foreground mt-3">
            <li>Monthly team meetings to share best practices</li>
            <li>Advanced technique workshops (green pool recovery, equipment repair)</li>
            <li>One-on-one coaching for performance improvement</li>
            <li>Updates on new products, chemicals, and techniques</li>
            <li>Business development training for upselling services</li>
          </ul>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Training Resources</h2>
          <p className="text-muted-foreground">
            Throughout your training and beyond, you'll have access to:
          </p>
          <ul className="list-disc list-inside space-y-2 text-muted-foreground mt-3">
            <li>This comprehensive wiki with detailed procedures</li>
            <li>Chemical reference guides and dosing calculators</li>
            <li>Equipment troubleshooting manuals</li>
            <li>Video tutorials on advanced techniques</li>
            <li>Direct support from experienced technicians and management</li>
          </ul>
        </section>
      </WikiPage>
    </WikiLayout>
  );
};

export default Training;